/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserBasicInfo } from './UserBasicInfo';
import {
    UserBasicInfoFromJSON,
    UserBasicInfoFromJSONTyped,
    UserBasicInfoToJSON,
    UserBasicInfoToJSONTyped,
} from './UserBasicInfo';

/**
 * 
 * @export
 * @interface ListUserResponse
 */
export interface ListUserResponse {
    /**
     * 
     * @type {Array<UserBasicInfo>}
     * @memberof ListUserResponse
     */
    users: Array<UserBasicInfo>;
    /**
     * 
     * @type {string}
     * @memberof ListUserResponse
     */
    nextToken: string;
}

/**
 * Check if a given object implements the ListUserResponse interface.
 */
export function instanceOfListUserResponse(value: object): value is ListUserResponse {
    if (!('users' in value) || value['users'] === undefined) return false;
    if (!('nextToken' in value) || value['nextToken'] === undefined) return false;
    return true;
}

export function ListUserResponseFromJSON(json: any): ListUserResponse {
    return ListUserResponseFromJSONTyped(json, false);
}

export function ListUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'users': ((json['users'] as Array<any>).map(UserBasicInfoFromJSON)),
        'nextToken': json['nextToken'],
    };
}

export function ListUserResponseToJSON(json: any): ListUserResponse {
    return ListUserResponseToJSONTyped(json, false);
}

export function ListUserResponseToJSONTyped(value?: ListUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'users': ((value['users'] as Array<any>).map(UserBasicInfoToJSON)),
        'nextToken': value['nextToken'],
    };
}

